type FormFile = File | undefined | null

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const generateFormData = (data: Record<string, any>, files: FormFile[], fileNames: string[] = []) => {
  const bodyFormData = new FormData()
  Object.keys(data).forEach((key) => {
    bodyFormData.append(key, data[key])
  })

  files.forEach((file, index) => {
    if (file) {
      const fileName = fileNames[index] ?? `file${index}`
      bodyFormData.append(fileName, file)
    }
  })

  return bodyFormData
}
